function concipientEventRegistration() {
  const temporaryRegistrationId = document.getElementById(
    'temporary-registration-id'
  ).dataset.temporaryRegistrationId;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(async function (mutation) {
      if (mutation.target.classList.contains('is-open')) {
        createConcipientEventParticipant(temporaryRegistrationId);
        watchAdditionalCheckboxesForConcipient(temporaryRegistrationId);
      }
    });
  });

  observer.observe(document.querySelector('#modal-register-concipient'), {
    attributes: true,
    attributeFilter: ['class'],
  });
}

function createConcipientEventParticipant(temporaryRegistrationId) {
  const participantId = document.getElementById('participant-id');

  $.ajax({
    type: 'POST',
    url: '/api/concipient/create-registration',
    data: {
      temporaryRegistrationId: temporaryRegistrationId,
    },
    success: function (data) {
      participantId.dataset.participantId = data.id;
    },
  });
}

function watchAdditionalCheckboxesForConcipient(temporaryRegistrationId) {
  let additionalCheckboxes = document.getElementsByClassName(
    'additional-checkbox-concipient'
  );
  additionalCheckboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', (event) => {
      let checkbox = event.currentTarget;
      if (checkbox.checked) {
        addAdditionalToConcipientUser(
          checkbox.dataset.eventId,
          checkbox.dataset.employeeId,
          checkbox.dataset.additionalId,
          temporaryRegistrationId
        );
        calculateConcipientPrice();
      } else {
        removeAdditionalFromConcipientUser(
          checkbox.dataset.eventId,
          checkbox.dataset.employeeId,
          checkbox.dataset.additionalId,
          temporaryRegistrationId
        );
        calculateConcipientPrice();
      }
    });
  });
}

function addAdditionalToConcipientUser(
  eventId,
  employeeId,
  additionalId,
  temporaryRegistrationId
) {
  $.ajax({
    type: 'POST',
    url: '/api/concipient/add-event-additional',
    data: {
      eventId: eventId,
      employeeId: employeeId,
      additionalId: additionalId,
      temporaryRegistrationId: temporaryRegistrationId,
    },
    success: function (data) {},
  });
}

function removeAdditionalFromConcipientUser(
  eventId,
  employeeId,
  additionalId,
  temporaryRegistrationId
) {
  $.ajax({
    type: 'POST',
    url: '/api/concipient/remove-event-additional',
    data: {
      eventId: eventId,
      employeeId: employeeId,
      additionalId: additionalId,
      temporaryRegistrationId: temporaryRegistrationId,
    },
    success: function (data) {},
  });
}

function calculateConcipientPrice() {
  const totalWithoutVatDiv = document.getElementById('total-without-vat');
  const dphPercent = document.getElementById('event-dph-id').dataset.eventDphPercent;
  const vatDiv = document.getElementById('total-vat');
  const totalWithVatDiv = document.getElementById('total-with-vat');
  const summaryRegisterDiv = document.getElementById('summary-register');
  let participantPrice = parseInt(
    document.getElementById('event-price-id').dataset.eventPrice
  );

  summaryRegisterDiv.innerHTML = '';
  summaryRegisterDiv.innerHTML =
    '<div class="summary__desc">Účasník</div>' +
    '<div>1</div>' +
    '<div><strong>' +
    formatNumber(participantPrice) +
    ' Kč</strong></div>';

  let additionalCheckboxes = document.getElementsByClassName(
    'additional-checkbox-concipient'
  );
  let resolvedCheckboxes = [];

  additionalCheckboxes.forEach(function (checkbox) {
    if (checkbox.checked) {
      let index = resolvedCheckboxes.findIndex(
        (element) => element.name === checkbox.dataset.additionalName
      );
      if (index < 0) {
        resolvedCheckboxes.push({
          name: checkbox.dataset.additionalName,
          count: 1,
          price: parseInt(checkbox.dataset.additionalPrice),
        });
      } else {
        resolvedCheckboxes[index] = {
          name: checkbox.dataset.additionalName,
          count: resolvedCheckboxes[index].count + 1,
          price:
            parseInt(resolvedCheckboxes[index].price) +
            parseInt(checkbox.dataset.additionalPrice),
        };
      }
    }
  });

  let totalCheckboxPrice = 0;
  resolvedCheckboxes.forEach(function (resolvedCheckbox) {
    totalCheckboxPrice += resolvedCheckbox.price;
    summaryRegisterDiv.innerHTML =
      summaryRegisterDiv.innerHTML +
      '<div class="summary__desc">' +
      resolvedCheckbox.name +
      '</div>' +
      '                        <div>' +
      resolvedCheckbox.count +
      '</div>' +
      '                        <div><strong>' +
      formatNumber(resolvedCheckbox.price) +
      ' Kč</strong></div>';
  });

  let totalWithoutVatPrice = participantPrice + totalCheckboxPrice;
  totalWithoutVatDiv.innerHTML = formatNumber(totalWithoutVatPrice.toFixed(2)) + ' Kč';
  totalWithVatDiv.innerHTML = formatNumber((totalWithoutVatPrice * (1 + dphPercent / 100)).toFixed(2)) + ' Kč';
  vatDiv.innerHTML =
    formatNumber((totalWithoutVatPrice * (1 + dphPercent / 100) - totalWithoutVatPrice).toFixed(2)) + ' Kč';
}
